import paydayAssets from '../src/scenes/SalesPages/PayDay/payDayImages.js';

const preloadImage = (src) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = src;
    img.onload = resolve;
    img.onerror = resolve;
  });
};

export const preloadPayDayImages = async () => {
  const allImages = [
    paydayAssets.heroImage,
    paydayAssets.weekendHeroBanner,
    paydayAssets.gateWayHeroBanner,
    paydayAssets.bgImage,
    paydayAssets.metric,
    paydayAssets.close,
    ...Object.values(paydayAssets.categories),
    ...Object.values(paydayAssets.gateway_categories),
    ...Object.values(paydayAssets.rewards),
    ...Object.values(paydayAssets.brands),
    ...Object.values(paydayAssets.otherBrands),
    ...Object.values(paydayAssets.secure),
    ...Object.values(paydayAssets.app),
    ...Object.values(paydayAssets.online),
    ...Object.values(paydayAssets.offline),
    ...Object.values(paydayAssets.userInfo),
  ].filter(Boolean); // remove undefined

  await Promise.all(allImages.map(preloadImage));
};
